<template>
  <v-autocomplete hide-details @input="event => { emitChange(event) }" :items="beltList" v-model="selectedBelt"
    :label="$t('message.select_belt')" item-text="text" item-value="value" clearable outlined dense>
    <template slot="item" slot-scope="data">
      <template v-if="!data.item.text">
        <v-list-item-content v-text="data.item"></v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-action>
          <img style="height: 20px;margin-right:5px" :src="data.item.avatar" />
        </v-list-item-action>
        <v-list-item-content class="text-left">
          <v-list-item-title v-html="data.item.text"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      selectedBelt: "",
      beltList: [
        {
          text: this.$t("message.gray"),
          value: "gray",
          avatar: this.assets() + "/belts/gray_belt.png"
        },
        {
          text: this.$t("message.yellow"),
          value: "yellow",
          avatar: this.assets() + "/belts/yellow_belt.png"
        },
        {
          text: this.$t("message.orange"),
          value: "orange",
          avatar: this.assets() + "/belts/orange_belt.png"
        },
        {
          text: this.$t("message.green"),
          value: "green",
          avatar: this.assets() + "/belts/green_belt.png"
        },
        {
          text: this.$t("message.white"),
          value: "white",
          avatar: this.assets() + "/belts/white_belt.png"
        },
        {
          text: this.$t("message.blue"),
          value: "blue",
          avatar: this.assets() + "/belts/blue_belt.png"
        },
        {
          text: this.$t("message.purple"),
          value: "purple",
          avatar: this.assets() + "/belts/purple_belt.png"
        },
        {
          text: this.$t("message.brown"),
          value: "brown",
          avatar: this.assets() + "/belts/brown_belt.png"
        },
        {
          text: this.$t("message.black"),
          value: "black",
          avatar: this.assets() + "/belts/black_belt.png"
        }
      ]
    };
  },
  props: {
    value: null,
    showIcon: null
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedBelt = newValue;
      }
    }
  },
  methods: {
    emitChange(event) {
      this.$emit("input", event);
    }
  }
};
</script>

<style scoped></style>